import DashboardInfoSection from './DashboardInfoSection';
import { DashboardInfoSectionProps, DashboardInfoSectionValueProps } from './types';

export type { DashboardInfoSectionProps, DashboardInfoSectionValueProps };
export default DashboardInfoSection;
